<template>
    <div>
        <!--基本信息-->
        <div class="common-form">基本信息</div>
        <el-form-item label="商品名称：" :rules="[{ required: true, message: '请填写商品名称' }]" prop="model.goods_name">
            <el-input v-model="form.model.goods_name" class="max-w460"></el-input>
        </el-form-item>
        <el-form-item label="商品简称：" prop="model.goods_single_name">
            <el-input v-model="form.model.goods_single_name" class="max-w460"></el-input>
        </el-form-item>
        <el-form-item label="所属分类：" :rules="[{ required: true, message: '请选择商品分类' }]" prop="model.category_id">
            <el-select v-model="form.model.category_id" filterable>
                <template v-for="cat in form.category">
                    <el-option :key="cat.category_id" :value="cat.category_id" :label="cat.name"></el-option>
                    <template v-for="two in cat.child" v-if="cat.child !== undefined">
                        <el-option :key="two.category_id" :value="two.category_id" :label="two.name" style="padding-left: 30px;"></el-option>
                        <template v-for="three in two.child" v-if="two.child !== undefined">
                            <el-option :key="three.category_id" :value="three.category_id" :label="three.name" style="padding-left: 60px;"></el-option>
                        </template>
                    </template>
                </template>
            </el-select>
        </el-form-item>
        <el-form-item label="预告商品：">
            <el-radio-group v-model="form.model.is_preview">
                <el-radio :label="1">开启</el-radio>
                <el-radio :label="0">关闭</el-radio>
            </el-radio-group>
        </el-form-item>
        <el-form-item v-if="form.model.is_preview == 1" label="预告开启购买时间" :rules="[{ required: true, message: '请选择开启购买时间' }]" prop="model.preview_time">
            <el-date-picker v-model="form.model.preview_time" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期"> </el-date-picker>
        </el-form-item>
        <el-form-item label="销售状态：">
            <el-radio-group v-model="form.model.goods_status">
                <el-radio :label="10">立即上架</el-radio>
                <el-radio :label="20">放入仓库</el-radio>
            </el-radio-group>
            <div class="gray9">如果平台开启了商品审核，则商品审核通过后才能销售</div>
        </el-form-item>
        <el-form-item v-if="form.audit_setting.add_audit == 1 && form.scene == 'add'" label="是否审核：">
            <el-radio-group v-model="form.model.audit_status">
                <el-radio :label="0">提交审核</el-radio>
                <el-radio :label="40">保存草稿</el-radio>
            </el-radio-group>
            <div class="gray9">当前平台开启了审核，审核通过后才能上架销售</div>
        </el-form-item>
        <el-form-item v-if="form.audit_setting.edit_audit == 1 && form.scene != 'add'" label="是否审核：">
            <el-radio-group v-model="form.model.audit_status">
                <el-radio :label="0">提交审核</el-radio>
                <el-radio :label="40">保存草稿</el-radio>
            </el-radio-group>
            <div class="gray9">当前平台开启了修改审核，审核通过后才能上架销售</div>
        </el-form-item>
        <el-form-item label="商品图片：" :rules="[{ required: true, message: '请上传商品图片' }]" prop="model.image">
            <div class="draggable-list">
                <draggable v-model="form.model.image" class="wrapper">
                    <transition-group>
                        <div v-for="(item, index) in form.model.image" :key="item.file_path" class="item">
                            <el-image :src="item.file_path" :preview-src-list="[item.file_path]" style="width: 110px; height: 110px;"></el-image>
                            <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(index)"><i class="el-icon-close"></i></a>
                        </div>
                    </transition-group>
                </draggable>
                <div class="item img-select" @click="openGoodsUpload('image', 'image')"><i class="el-icon-plus"></i></div>
            </div>
        </el-form-item>
        <el-form-item label="商品视频：">
            <el-row>
                <div class="draggable-list">
                    <div v-if="form.model.video_id == 0" class="item img-select" @click="openGoodsUpload('video', 'video')"><i class="el-icon-plus"></i></div>
                    <div v-if="form.model.video_id != 0">
                        <video width="150" height="150" :src="form.model.video.file_path" :autoplay="false" controls>
                            您的浏览器不支持 video 标签
                        </video>
                        <div>
                            <el-button icon="el-icon-picture-outline" @click="delVideo">删除视频</el-button>
                        </div>
                    </div>
                </div>
            </el-row>
        </el-form-item>
        <el-form-item label="视频封面：">
            <el-row>
                <div class="draggable-list">
                    <div v-if="form.model.poster_id == 0" class="item img-select" @click="openGoodsUpload('image', 'poster')"><i class="el-icon-plus"></i></div>
                    <div v-if="form.model.poster_id != 0" class="item">
                        <el-image :src="form.model.poster.file_path" :preview-src-list="[form.model.poster.file_path]" style="width: 110px; height: 110px;"></el-image>
                        <a href="javascript:void(0);" class="delete-btn" @click.stop="delVideoImg()"><i class="el-icon-close"></i></a>
                    </div>
                </div>
            </el-row>
        </el-form-item>
        <el-form-item label="商品卖点：">
            <el-input v-model="form.model.selling_point" type="textarea" class="max-w460"></el-input>
        </el-form-item>

        <el-form-item label="选择供货商">
            <el-select v-model="form.model.supplier_id" placeholder="请选择">
                <el-option v-for="(item, index) in form.supplierlist" :key="index" :label="item.supplier_name" :value="item.supplier_id"></el-option>
            </el-select>
        </el-form-item>

        <!--其他设置-->
        <div class="common-form">其他设置</div>
        <el-form-item label="商品属性：">
            <el-radio-group v-model="form.model.is_virtual">
                <el-radio :label="0">实物商品</el-radio>
                <el-radio :label="1">虚拟商品(无需发货)</el-radio>
                <el-radio :label="2">计次商品(无需发货)</el-radio>
            </el-radio-group>
        </el-form-item>
        <el-form-item label="1688商品类型：">
            <el-radio-group v-model="form.model.goods_type_1688">
                <el-radio :label="0">现货</el-radio>
                <el-radio :label="1">分销</el-radio>
            </el-radio-group>
        </el-form-item>
        <el-form-item label="1688商品规格：" prop="model.goods_sku_name_1688">
            <el-input v-model="form.model.goods_sku_name_1688" class="max-w460"></el-input>
        </el-form-item>
        <el-form-item v-if="form.model.is_virtual == 0" label="运费模板：" prop="model.delivery_id">
            <el-radio-group v-model="form.model.is_delivery_free" @change="changeDelivery">
                <el-radio :label="0">包邮</el-radio>
                <el-radio :label="1">运费模板</el-radio>
            </el-radio-group>
            <el-select v-if="form.model.is_delivery_free == 1" v-model="form.model.delivery_id">
                <el-option v-for="item in form.delivery" :key="item.delivery_id" :value="item.delivery_id" :label="item.name"></el-option>
            </el-select>
            <el-link v-if="form.model.is_delivery_free == 1" type="primary" :underline="false" @click="setExpress">去设置</el-link>
        </el-form-item>
        <el-form-item label="初始销量：">
            <el-input v-model="form.model.sales_initial" type="number" min="0" class="max-w460"></el-input>
        </el-form-item>
        <el-form-item label="商品标签：">
            <el-checkbox v-model="form.model.is_new" :true-label="1" :false-label="0">新品</el-checkbox>
            <el-checkbox v-model="form.model.is_hot" :true-label="1" :false-label="0">热销</el-checkbox>
            <el-checkbox v-model="form.model.is_recommend" :true-label="1" :false-label="0">推荐</el-checkbox>
        </el-form-item>

        <el-form-item label="商品排序：" :rules="[{ required: true, message: ' ' }]" prop="model.goods_sort">
            <el-input v-model="form.model.goods_sort" type="number" min="0" class="max-w460"></el-input>
        </el-form-item>
        <el-form-item label="限购数量：" :rules="[{ required: true, message: ' ' }]" prop="model.limit_num">
            <el-input v-model="form.model.limit_num" type="number" min="0" class="max-w460"></el-input>
            <div class="gray9">每个会员购买的最大数量，0为不限购</div>
        </el-form-item>
        <el-form-item label="用户单次必须购买数量：" :rules="[{ required: true, message: ' ' }]" prop="model.minbuy">
            <el-input v-model="form.model.minbuy" type="number" min="0" class="max-w460"></el-input>
            <div class="gray9">用户单次必须购买数量，0为不限购</div>
        </el-form-item>
        <el-form-item label="货源网址：">
            <el-input v-model="form.model.source_url" class="max-w460"></el-input>
        </el-form-item>
        <el-form-item v-if="form.model.is_virtual == 1" label="发货类型：">
            <el-radio-group v-model="form.model.virtual_auto">
                <el-radio :label="1">自动</el-radio>
                <el-radio :label="0">手动</el-radio>
            </el-radio-group>
        </el-form-item>
        <el-form-item v-if="form.model.is_virtual == 1" label="虚拟内容：" :rules="[{ required: true, message: '请填写虚拟内容' }]" prop="model.virtual_content">
            <el-input v-model="form.model.virtual_content" type="text" class="max-w460"></el-input>
            <div class="gray9">虚拟物品内容</div>
        </el-form-item>
        <el-form-item label="自定义标签：">
            <el-tag
                :key="tag"
                v-for="tag in form.model.ext.attr"
                closable
                :disable-transitions="false"
                @close="handleClose(tag)">
                {{tag}}
            </el-tag>
            <el-input
                class="input-new-tag"
                v-if="inputVisible"
                v-model="inputValue"
                ref="saveTagInput"
                size="small"
                @keyup.enter.native="handleInputConfirm"
                @blur="handleInputConfirm"
            >
            </el-input>
            <el-button v-else class="button-new-tag" size="small" @click="showInput">+添加</el-button>
        </el-form-item>


        <!--商品图片组件-->
        <Upload v-if="isGoodsUpload" :config="config" :isupload="isGoodsUpload" @returnImgs="returnGoodsImgsFunc">上传图片</Upload>
    </div>
</template>

<script>
    import Upload from "@/components/file/Upload";
    import draggable from "vuedraggable";
    export default {
        components: {
            Upload,
            draggable
        },
        inject: ["form"],
        data() {
            return {
                isGoodsUpload: false,
                config: {},
                file_name: "image",
                inputVisible: false,
                inputValue: '',
            };
        },
        created() {},
        methods: {
            handleClose(tag) {
                this.form.model.ext.attr.splice(this.form.model.ext.attr.indexOf(tag), 1);
            },
            showInput() {
                this.inputVisible = true;
                this.$nextTick(_ => {
                    this.$refs.saveTagInput.$refs.input.focus();
                });
            },

            handleInputConfirm() {
                let inputValue = this.inputValue;
                if (inputValue) {
                    this.form.model.ext.attr.push(inputValue);
                }
                this.inputVisible = false;
                this.inputValue = '';
            },
            /*打开上传图片*/
            openGoodsUpload: function(file_type, file_name) {
                this.file_name = file_name;
                if (file_type == "image") {
                    this.config = {
                        total: 9,
                        file_type: "image"
                    };
                } else {
                    this.config = {
                        total: 1,
                        file_type: "video"
                    };
                }
                this.isGoodsUpload = true;
            },

            /*上传商品图片*/
            returnGoodsImgsFunc(e) {
                if (e != null) {
                    if (this.file_name == "video") {
                        this.form.model.video_id = e[0].file_id;
                        this.form.model.video = e[0];
                    } else if (this.file_name == "image") {
                        let imgs = this.form.model.image.concat(e);
                        this.$set(this.form.model, "image", imgs);
                    } else if (this.file_name == "poster") {
                        this.form.model.poster_id = e[0].file_id;
                        this.form.model.poster = e[0];
                    }
                }
                this.isGoodsUpload = false;
            },

            /*删除商品图片*/
            deleteImg(index) {
                this.form.model.image.splice(index, 1);
            },
            delVideo() {
                this.form.model.video_id = 0;
                this.form.model.video = {};
            },
            delVideoImg() {
                this.form.model.poster_id = 0;
            },
            /*打开添加*/
            setExpress() {
                this.$router.push("/setting/delivery/index");
            },
            changeDelivery(e) {
                if (e == 0) {
                    this.form.model.delivery_id = "";
                }
            }
        }
    };
</script>

<style>
    .edit_container {
        font-family: "Avenir", Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        line-height: 20px;
        color: #2c3e50;
    }

    .ql-editor {
        height: 400px;
    }

    .draggable-list {
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;
    }
    .draggable-list .wrapper > span {
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;
    }

    .draggable-list .item {
        position: relative;
        width: 110px;
        height: 110px;
        margin-top: 10px;
        margin-right: 10px;
        border-radius: 8px;
        overflow: hidden;
        border: 1px solid #dddddd;
    }

    .draggable-list .delete-btn {
        position: absolute;
        top: 0;
        right: 0;
        width: 16px;
        height: 16px;
        background: red;
        line-height: 16px;
        font-size: 16px;
        color: #ffffff;
        display: none;
    }

    .draggable-list .item:hover .delete-btn {
        display: block;
    }

    .draggable-list .item img {
        position: absolute;
        top: 50%;
        left: 50%;
        -webkit-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
        max-height: 100%;
        max-width: 100%;
    }

    .draggable-list .img-select {
        display: flex;
        justify-content: center;
        align-items: center;
        border: 1px dashed #dddddd;
        font-size: 30px;
    }

    .draggable-list .img-select i {
        color: #409eff;
    }
    .el-tag {
        margin-right: 10px;
    }
    .button-new-tag {
        height: 32px;
        line-height: 30px;
        padding-top: 0;
        padding-bottom: 0;
    }
    .input-new-tag {
        width: 90px;
        vertical-align: bottom;
    }
</style>



// WEBPACK FOOTER //
// src/views/goods/goods/part/Basic.vue